import { A, useRouteData } from "@solidjs/router"
import { onMount, Show } from "solid-js"
import { createStore } from "solid-js/store"
import { ArtworkImage } from "../library/types";
import { Img } from "../components/universal/image";

type State = {
    isContentReady: boolean;
}

export function IndexPage() {
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    const [model, setModel] = createStore<ArtworkImage>({ } as ArtworkImage);
    onMount(async () => {
        const routeData = await useRouteData() as any;
        setModel(routeData.artistPortrait);
        setState("isContentReady", true);
    })
    return (
        <>
            <section style="margin: 10px 20px;">
                <h1 style="font-size: 3rem;">
                    <Show when={state.isContentReady}>
                        Image of {model.Artist.FirstName} {model.Artist.LastName}
                    </Show>
                    <Show when={!state.isContentReady}>
                        Image of the artist
                    </Show>
                </h1>
                <p>
                    <span>
                        <a href="/">Home</a> / <a href="/Museum/Home">Museum</a> / <A href="/">Artist Portraits</A>
                    </span>
                </p>
            </section>
            <Show when={state.isContentReady}>
                <div class="row">
                    <div class="col-md-4">
                        <div style="background-color: #000; display: table-cell; vertical-align: middle;">
                            <Img src={model.PrimaryImage.URL} mode="crop" width={600} style="width: 600px; height: auto;" />
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div style="background-color: #fff; color: #333;">
                            <div style="border-bottom: 1px dotted #ccc; margin-bottom: 20px; padding-bottom: 20px;">
                                <A href="/search">Back to Search</A>
                            </div>
                            <h1 style="font-size: 4rem;">
                                <a href={`/artists/${model.Artist.Slug}/${model.Artist.Id}`}>{model.Artist.FirstName} {model.Artist.LastName}</a>
                            </h1>
                            <h3>
                                {model.Artist.BirthYear||"?"}&mdash;{model.Artist.DeathYear||"?"}
                            </h3>
                            <Show when={model.Content || model.Artist.BiographyText}>
                                <div innerHTML={model.Content || model.Artist.BiographyText}></div>
                            </Show>
                        </div>
                    </div>
                </div>
            </Show>
        </>
    )
}
